import * as React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

interface LogoWrapperProps {
  inverse: boolean;
  size: number;
}

const LogoWrapper = styled.span`
  color: ${(props: LogoWrapperProps) => (props.inverse ? '#49356c' : '#fff')};
  font-size: ${(props: LogoWrapperProps) => `${props.size}em`};
  text-shadow: ${(props: LogoWrapperProps) =>
    !props.inverse ? 'rgba(0, 0, 0, 0.5) 0px -1px' : 'none'};
  cursor: pointer;

  > * {
    vertical-align: middle;
  }
`;

const LogoLeft = styled.span`
  font-weight: 600;
`;

const LogoRight = styled.span`
  font-weight: 200;
`;

const Tagline = styled.span`
  /* Hide tagline on mobile because it's too long! */
  @media (max-width: 768px) {
    display: none;
  }
  font-size: 0.9em;
  font-weight: 200;
`;

const TaglineSeparator = styled.span`
  padding: 0 0.5em;
`;

const Img = styled.img`
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.5em;
`;

interface Props {
  showIcon: boolean;
  showTagline: boolean;
  inverse: boolean;
  size: number;
}

export const Logo: React.SFC<Props> = props => (
  <LogoWrapper inverse={props.inverse} size={props.size}>
    {props.showIcon && (
      <Img src="//s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/logo_inverse.svg" />
    )}
    <LogoLeft>
      <FormattedMessage id="logoLeftText" />
    </LogoLeft>
    <LogoRight>
      <FormattedMessage id="logoRightText" />
    </LogoRight>
    {props.showTagline && (
      <Tagline>
        <TaglineSeparator>|</TaglineSeparator>
        <FormattedMessage id="logoSloganTextOnly" />
      </Tagline>
    )}
  </LogoWrapper>
);



// WEBPACK FOOTER //
// ./app/components/common/Logo.tsx